module.exports = "/_next/static/images/a55e922a2c0fd810d7f3984a5ae05c6c-ballons-icon.svg";